export default __webpack_public_path__ + "static/media/sideCarrot.46e796b9.svg";